<template>
  <div class="project-register-edit">
    <div class="text-right">
      <Button type="primary" ghost @click="clickImportExcelControl">从Excel导入</Button>
      <input type="file" accept="application/msexcel" @change="importExcel" style="display:none" name="importExcelControl" id="importExcelControl" />
    </div>
    <div class="padding-top-20"></div>
    <Form ref="newForm" :model="projectModel"
          :rules="modelValidate"
          label-position="left">
      <table class="brief-table">
        <tbody>
          <tr>
            <td class="title" colspan="6">监管信息</td>
          </tr>
          <tr>
            <td class="title">地区</td>
            <td>
              <FormItem prop="cityId">
                <Select v-model="projectModel.cityId">
                  <Option v-for="(city,cId) in cities" :key="cId" :value="city.tid">{{ city.name }}</Option>
                </Select>
              </FormItem>
            </td>
            <td class="title">行业/领域</td>
            <td>
              <FormItem prop="industryId">
                <Select v-model="projectModel.industryId">
                  <Option v-for="(inds,cId) in industries" :key="cId" :value="inds.id">{{ inds.name }}</Option>
                </Select>
              </FormItem>
            </td>
            <td class="title">保证金监管方</td>
            <td>
              <FormItem prop="supervisorName">
                <Input v-model="projectModel.supervisorName" placeholder="保证金监管方" />
              </FormItem>
            </td>
          </tr>
          <tr>
            <td class="title" colspan="6">项目信息</td>
          </tr>
          <tr>
            <td class="title">项目名称</td>
            <td colspan="5">
              <FormItem prop="projectName">
                <Input v-model="projectModel.projectName" placeholder="输入项目名称" />
              </FormItem>
            </td>
          </tr>
          <tr>
            <td class="title">工程地址</td>
            <td colspan="3">
              <FormItem prop="projectSite">
                <Input v-model="projectModel.projectSite" placeholder="输入工程地址" />
              </FormItem>
            </td>
            <td class="title">结构形式</td>
            <td>
              <FormItem prop="projectStruc">
                <Input v-model="projectModel.projectStruc" placeholder="输入结构形式" />
              </FormItem>
            </td>
          </tr>
          <tr>
            <td class="title">中标价(元)</td>
            <td>
              <FormItem prop="projectCost">
                <InputNumber :min="0" :step="10000"
                  style="width: 150px;display:inline-block"
                  v-model="projectModel.projectCost"
                  @on-change="projectCostChange"
                  placeholder="输入中标价(元)"></InputNumber>
              </FormItem>
              <div class="small font-grey">{{$common.transformNumberIntoCHS(projectModel.projectCost)}}</div>
            </td>
            <td class="title">建设规模</td>
            <td>
              <FormItem prop="projectScale">
                <InputNumber :min="0" :step="10000" style="width: 200px" v-model="projectModel.projectScale" placeholder="输入建设规模(m/m²/m³)"></InputNumber>
              </FormItem>
              <div class="small font-grey">路桥写XXm，建筑单位写XX㎡</div>
            </td>
            <td class="title">开竣工日期(计划)</td>
            <td>
              <FormItem prop="projectStartDate">
                <DatePicker v-model="projectModel.daterange"
                  @on-change="prjDateChange"
                  type="daterange"
                  placement="bottom-end"
                  format="yyyy/MM/dd"
                  placeholder="选择开竣工日期(计划)"
                  style="width: 100%"></DatePicker>
              </FormItem>
            </td>
          </tr>
          <tr>
            <td class="title">建设单位名称</td>
            <td>
              <FormItem prop="ownerName">
                <Input v-model="projectModel.ownerName" placeholder="建设单位名称" />
              </FormItem>
            </td>
            <td class="title">负责人</td>
            <td>
              <FormItem prop="ownerManager">
                <Input v-model="projectModel.ownerManager" placeholder="建设单位负责人" />
              </FormItem>
            </td>
            <td class="title">联系电话</td>
            <td>
              <FormItem prop="ownerManagerTel">
                <Input v-model="projectModel.ownerManagerTel" placeholder="建设单位负责人联系电话" />
              </FormItem>
            </td>
          </tr>
          <tr>
            <td class="title">施工总包单位名称</td>
            <td>
              <FormItem prop="contractorName">
                <Input v-model="projectModel.contractorName" placeholder="施工总承包单位名称" />
              </FormItem>
            </td>
            <td class="title">项目经理</td>
            <td>
              <FormItem prop="contractorManager">
                <Input v-model="projectModel.contractorManager" placeholder="总承包单位负责人" />
              </FormItem>
            </td>
            <td class="title">联系电话</td>
            <td>
              <FormItem prop="contractorManagerTel">
                <Input v-model="projectModel.contractorManagerTel" placeholder="总承包单位负责人联系电话" />
              </FormItem>
            </td>
          </tr>
          <tr>
            <td class="title" colspan="6">保证金存储信息</td>
          </tr>
          <tr>
            <td class="title">存储基数(元)</td>
            <td>
              <FormItem prop="payableBase">
                <InputNumber :min="0" :step="10000"
                  @on-change="calcPayableAmount"
                  style="width: 150px;display:inline-block"
                  v-model="projectModel.payableBase"
                  placeholder="输入存储基数(中标价,元)"></InputNumber>
              </FormItem>
              <div class="small font-grey">{{$common.transformNumberIntoCHS(projectModel.payableBase)}}</div>
            </td>
            <td class="title">应存储金额(元)</td>
            <td>
              <FormItem prop="payableAmount">
                <InputNumber :min="0" :step="10000"
                  @on-change="calcPayableRatio"
                  style="width: 150px;display:inline-block"
                  v-model="projectModel.payableAmount"
                  placeholder="输入应存储金额(元)"></InputNumber>
              </FormItem>
              <div class="small font-grey">{{$common.transformNumberIntoCHS(projectModel.payableAmount)}}</div>
            </td>
            <td class="title">存储比例(%)</td>
            <td>
              <FormItem prop="payableRatio">
                <InputNumber :min="0" :step="1"
                  @on-change="calcPayableAmount"
                  style="width: 150px;display:inline-block"
                  v-model="projectModel.payableRatio"
                  placeholder="输入存储比例(%)"></InputNumber>
              </FormItem>
            </td>
          </tr>
          <tr>
            <td class="title">存储方式</td>
            <td>
              <FormItem prop="method">
                <RadioGroup v-model="projectModel.method" type="button" button-style="solid">
                  <Radio :label="0">保函</Radio>
                  <Radio :label="1">现金</Radio>
                </RadioGroup>
              </FormItem>
            </td>
            <td class="title">保证金经办人</td>
            <td>
              <FormItem prop="opName">
                <Input v-model="projectModel.opName" placeholder="保证金经办人" />
              </FormItem>
            </td>
            <td class="title">经办人电话</td>
            <td>
              <FormItem prop="opTel">
                <Input v-model="projectModel.opTel" placeholder="保证金经办人联系电话" />
              </FormItem>
            </td>
          </tr>
          <tr>
            <td class="title" colspan="6">保证金经办机构信息</td>
          </tr>
          <tr>
            <td class="title">机构名称</td>
            <td colspan="3">
              <FormItem prop="guarantorName">
                <Input v-model="projectModel.guarantorName" placeholder="保证金经办机构名称" />
              </FormItem>
            </td>
            <td class="title">联系人</td>
            <td>
              <FormItem prop="guarantorContact">
                <Input v-model="projectModel.guarantorContact" placeholder="保证金经办机构联系人" />
              </FormItem>
            </td>
            
          </tr>
          <tr>
            <td class="title">地址</td>
            <td colspan="3">
              <FormItem prop="guarantorAddress">
                <Input v-model="projectModel.guarantorAddress" placeholder="保证金经办机构地址" />
              </FormItem>
            </td>
            <td class="title">电话</td>
            <td>
              <FormItem prop="guarantorTel">
                <Input v-model="projectModel.guarantorTel" placeholder="保证金经办机构联系人电话" />
              </FormItem>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="padding-top-20"></div>
      <div class="text-center">
        <Button type="primary" style="width:320px" size="large" @click="submit">保存</Button>
      </div>
    </Form>
  </div>
</template>

<script>
import Api from './../../../api/Api.js'
import xlsx from 'xlsx'
export default {
  name: 'project-register-edit',
  props: {
  },
  data () {
    return {
      loading: false,
      projectModel: {
        industryId: null,
        cityId: null,
        method: null, // 存储方式：0-保函|1-现金
        projectName: null,
        projectSite: null,
        projectStruc: null,
        projectScale: null,
        projectCost: 0,
        projectStartDate: null,
        projectEndDate: null,
        daterange: null,
        duration: null,
        ownerName: null,
        ownerManager: null,
        ownerManagerTel: null,
        contractorName: null,
        contractorManager: null,
        contractorManagerTel: null,
        payableBase: 0,
        payableAmount: 0,
        payableRatio: 2,
        opName: null,
        opTel: null,
        supervisorName: null,
        guarantorName: null,
        guarantorAddress: null,
        guarantorContact: null,
        guarantorTel: null,
      },
      modelValidate: {
        projectName: [
          { required: true, message: '请填写项目名称', trigger: 'blur' }
        ],
        industryId: [
          { required: true, type: 'number', message: '请选择所属行业/领域', trigger: 'blur' }
        ],
        projectCost: [
          { required: true, type: 'number', message: '请填写中标价', trigger: 'blur' }
        ],
        payableBase: [
          { required: true, type: 'number', message: '请填写存储基数', trigger: 'blur' }
        ],
        payableAmount: [
          { required: true, type: 'number', message: '请填写应存储金额', trigger: 'blur' }
        ],
        payableRatio: [
          { required: true, type: 'number', message: '请填写存储比例', trigger: 'blur' }
        ],
        projectStartDate: [
          { required: true, message: '请填写开工日期', trigger: 'blur' }
        ],
        ownerName: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        ownerManager: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        ownerManagerTel: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        contractorName: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        contractorManager: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        contractorManagerTel: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        opName: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        opTel: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        supervisorName: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
      },
      cities: [],
      industries: []
    }
  },
  watch: {
  },
  mounted () {
    this.init()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    async init () {
      await this.getDetail()
      this.initMyCities()
      this.initMyIndustries()
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '监管人') {
        this.projectModel.supervisorName = this.$store.getters.supervisorInfo.name
      }
    },
    getDetail () {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$Spin.show()
        Api.ProjectRegister.getProjectRegisterDetail(this.$route.params.orderNumber)
          .then((payload) => {
            payload.payableRatio = Math.round(payload.payableRatio * 100 * 100) / 100
            payload.payableAmount /= 100
            payload.payableBase /= 100
            payload.projectCost /= 100
            payload.projectStartDate = this.$moment(payload.projectStartDate).format('YYYY-MM-DD')
            payload.projectEndDate = this.$moment(payload.projectEndDate).format('YYYY-MM-DD')
            payload.daterange = [this.$moment(payload.projectStartDate).format('YYYY-MM-DD'), this.$moment(payload.projectEndDate).format('YYYY-MM-DD')]
            this.projectModel = payload
            this.loading = false
            this.$Spin.hide()
            resolve()
          })
          .catch(err => {
            console.log('err', err)
            this.$Message.error('载入失败!' + err.message)
            this.loading = false
            this.$Spin.hide()
            reject(err)
          })
      })
    },
    readXlsx (fileData) {
      // 通过文件读取
      const workBook = xlsx.read(fileData, {type: 'binary'})
      // console.log(workBook)
      const dataRows = xlsx.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]], {header: 1})
      // const listNew = list.concat(xlsx.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]], {header: 1}))
      console.log(dataRows)
      let list = []
      if (dataRows.length > 1) {
        dataRows.forEach((row) => {
          let startDate = row[15].replace(/[年月]/g, '-').replace(/日/g, '')
          let endDate = row[16].replace(/[年月]/g, '-').replace(/日/g, '')
          // let cashMethod = row[17]
          let guaMethod = row[18]
          let projectScale = row[14].match(/-?\d*\.?\d+/)
          if (projectScale) {
            projectScale = projectScale[0]
          }
          let guarantorName = row[23] ? row[23].trim() : null
          if (guarantorName === '/') {
            guarantorName = null
          }
          let guarantorAddress = row[25] ? row[25].trim() : null
          if (guarantorAddress === '/') {
            guarantorAddress = null
          }
          let guarantorContact = row[24] ? row[24].trim() : null
          if (guarantorContact === '/') {
            guarantorContact = null
          }
          let guarantorTel = row[26] ? row[26].trim() : null
          if (guarantorTel === '/') {
            guarantorTel = null
          }
          let payableBase = row[19]
          if (payableBase === '/') {
            payableBase = row[13]
          }
          let payableRatio = row[20]
          if (payableRatio === '/') {
            payableRatio = 2
          } else {
            payableRatio = parseFloat(payableRatio)
          }
          let payableAmount = row[21]
          if (payableAmount === '/') {
            payableAmount = Math.round(payableRatio * payableBase / 100) // 四舍五入到元
            if (payableAmount > 20000000) {
              payableAmount = 20000000
            }
          }
          let data = {
            method: guaMethod ? 0 : 1, // 存储方式：0-保函|1-现金
            projectName: row[2],
            projectSite: row[6],
            projectStruc: row[12],
            projectScale: projectScale,
            projectCost: row[13],
            projectStartDate: this.$moment(startDate).format('YYYY-MM-DD'),
            projectEndDate: this.$moment(endDate).format('YYYY-MM-DD'),
            daterange: [this.$moment(startDate).format('YYYY-MM-DD'), this.$moment(endDate).format('YYYY-MM-DD')],
            ownerName: row[3],
            ownerManager: row[4],
            ownerManagerTel: row[5],
            contractorName: row[7],
            contractorManager: row[8],
            contractorManagerTel: row[9],
            payableBase: payableBase,
            payableAmount: payableAmount,
            payableRatio: payableRatio,
            opName: row[10],
            opTel: row[11],
            supervisorName: row[22],
            guarantorName: guarantorName,
            guarantorAddress: guarantorAddress,
            guarantorContact: guarantorContact,
            guarantorTel: guarantorTel
          }
          list.push(data)
        })
        Object.assign(this.projectModel, list[1])
      }
    },
    importExcel (e) {
      // console.log(e)
      let files = e.target.files
      // 构建fileReader对象
      const fileReader = new FileReader()
      // 读取操作完成时
      let that = this
      fileReader.onload = function(evt) {
        try {
          // 二进制数据
          // console.log(evt.target.result)
          that.readXlsx(evt.target.result)
        } catch (err) {
          // console.log(err)
          console.log('文件读取错误', err)
          this.$Message.error('文件读取错误!' + err.message)
          return
        }
      }
      // 读取指定文件内容
      fileReader.readAsBinaryString(files[0])
    },
    clickImportExcelControl () {
      let ctrl = document.getElementById('importExcelControl')
      ctrl.click()
    },
    initMyCities () {
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '监管人') {
        let mySupvCities = this.$store.getters.supervisorInfo.cities.map((c) => {
          return c.city
        })
        this.cities = mySupvCities
        if (mySupvCities.length === 1) {
          this.projectModel.cityId = mySupvCities[0].tid
        }
      }
    },
    initMyIndustries () {
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '监管人') {
        let mySupvIndustries = this.$store.getters.supervisorInfo.industries.map((c) => {
          return c.industry
        })
        this.industries = mySupvIndustries
        if (mySupvIndustries.length === 1) {
          this.projectModel.industryId = mySupvIndustries[0].id
        }
      }
    },
    projectCostChange (val) {
      this.projectModel.payableBase = val
      this.calcPayableAmount()
    },
    calcPayableAmount () {
      this.projectModel.payableAmount = Math.round(this.projectModel.payableRatio * this.projectModel.payableBase / 100) // 四舍五入到元
      if (this.projectModel.payableAmount > 20000000) {
        this.projectModel.payableAmount = 20000000
      }
    },
    calcPayableRatio () {
      this.projectModel.payableRatio = Math.round(this.projectModel.payableAmount / this.projectModel.payableBase * 10000) / 100
    },
    prjDateChange (date) {
      console.log(date)
      if (date && date instanceof Array && date.length === 2) {
        this.projectModel.projectStartDate = require('moment')(date[0]).format('YYYY-MM-DD')
        this.projectModel.projectEndDate = require('moment')(date[1]).format('YYYY-MM-DD')
        this.projectModel.duration = require('moment')(date[1]).diff(require('moment')(date[0]), 'days')
      }
    },
    initCitySelect () {
      Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.projectModel.cityId = val[val.length - 1]
      } else {
        this.projectModel.cityId = val
      }
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          let model = Object.assign({}, this.projectModel)
          model.projectCost = Math.round(this.projectModel.projectCost * 100)
          model.payableAmount = Math.round(this.projectModel.payableAmount * 100)
          model.payableBase = Math.round(this.projectModel.payableBase * 100)
          model.payableRatio = this.projectModel.payableRatio / 100
          await Api.ProjectRegister.updateProjectRegister(model)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('修改成功!')
              this.loading = false
              this.$Spin.hide()
              this.$router.back()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    },
  }
}
</script>

<style lang="less">
.project-register-new {
  .ivu-form-item {
    margin-bottom: 0 !important;
  }
  .ivu-form-item-error-tip {
    position: initial !important;
  }
}
</style>
